<template>
<div id="main-content" class="taskboard">
        <div class="container-fluid">
            <div class="block-header">
                <div class="row">
                    <div class="col-lg-6 col-md-8 col-sm-12">
                        <h2><a href="javascript:void(0);" class="btn btn-xs btn-link btn-toggle-fullwidth"><i class="fa fa-arrow-left"></i></a> Tickets</h2>
                        <ul class="breadcrumb">
                            <li class="breadcrumb-item"><a href="index.html"><i class="icon-home"></i></a></li>                            
                            <li class="breadcrumb-item">Apps</li>
                            <li class="breadcrumb-item active">Tickets</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12">
                    <div class="card">
                        <div class="header">
                            <h2>Submission Target</h2>
                        </div>
                        <div class="body">
                            <app-modal :elements="modalElements" v-on:confirm="del"></app-modal>
                            <button type="button" class="btn btn-outline-primary" @click="add">Add  <i class="far fa-file"></i></button>
                            <button type="button" class="btn btn-outline-info" @click="edit">Edit <i class="far fa-edit"></i></button>
                            <button type="button" class="btn btn-outline-danger" data-toggle="modal" :data-target="`#${modalElements.modalId}`">Delete <i class="far fa-trash-alt"></i></button>
                            <app-datatable :type="'view'" :elements="dtElements" :collections="submissionTarget" v-on:selectedRow="selectRow"></app-datatable>
                            <app-data-pagination v-on:pageChanged="changePage"></app-data-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '../services/api'
import { submissionTarget } from '../models/submissionTarget'
import AppDatatable from '../components/AppDatatable.vue'
import AppModal from '../components/AppModal.vue'
import AppDataPagination from '../components/AppDataPagination.vue'
import AppDataSearch from '../components/AppDataSearch.vue'

export default {
    components: {
      AppDatatable, AppModal, AppDataPagination, AppDataSearch
    },
    data() {
      return {
        submissionTarget: [submissionTarget],
        dtElements: [
        {
          title: 'Employee ID',
          column: 'employeeId',
          type: 'text'
        },
        {
          title: 'Employee Name',
          column: 'employeeName',
          type: 'text'
        },
        {
          title: 'Target',
          column: 'target',
          type: 'text'
        },
      ],
      modalElements: {
        modalId: 'submission-target',
        title: 'Confirm',
        content: 'Are you sure to delete this data?'
      },
      selectedId: '',
      searchKey: '',
      pagination: {
        pageSize: 10,
        currentPage: 1
      }
    }
  },
  async created() {
    this.init()
  },
  methods: {
    async init() {
      const aqApi = api('submission-target/partial')
      const query = {
        params: {
          searchKey: this.searchKey,
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize
        }
      }
      this.submissionTarget = await aqApi.getWithQuery(query) 
    },
    add() {
      this.$router.push({ name: 'submissionTargetDetail' })
    },
    edit() {
      if(this.selectedId !== '') {
        this.$router.push({
          name: 'submissionTargetDetail',
          query: {
            id: this.selectedId
          }
        })
      }
    },
    async del() {
      if(this.selectedId !== '') {
        const stApi = api('submission-target')
        await stApi.delete(this.selectedId)
        this.init()
      }
    },
    selectRow(id) {
        this.selectedId = id
    },
    changePage(payload) {
        this.pagination = payload
        this.init()
    },
    search(searchKey) {
        this.searchKey = searchKey
        this.init()
    }
  }
}
</script>